const CURL_PROFILE = "curl-profile"
const CURL_PROFILE_ID = 1
const DEFAULT_REGIMEN_METHOD_ID = 1
const CURL_TYPES = {
    '2A': '1',
    '2B': '1',
    '2C': '1',
    '3A': '1',
    '3B': '1',
    '3C': '2',
    '4A': '2',
    '4B': '2',
    '4C': '1'
}

export const constants = {
    quizUrls: {
        CURL_PROFILE: CURL_PROFILE,
        CURL_PROFILE_ID: CURL_PROFILE_ID
    },
    regimenMethodId: {
        DEFAULT_REGIMEN_METHOD_ID: DEFAULT_REGIMEN_METHOD_ID
    },
    curlTypes : CURL_TYPES
}


// WEBPACK FOOTER //
// ./src/constants.js